export default __webpack_public_path__ + "images/8224eec95cf6383e3e76aa0afd759e74.png";